<template>
	<div class="px-5">
		<app-table
			class="mt-5 is-not-selectable"
			name="users"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-page="changePage"
			@on-search-event="onSearch"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
					v-show="showRow(columns, 1)"
				>
					{{ props.row.email }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.codeUser }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.company.data.nombreComercial }}
				</td>
				<td>
					<v-tooltip top>
						<v-btn icon slot="activator">
							<v-switch
								class="ml-3 mt-0"
								hide-details
								v-model="props.row.status" 
								@change="changeState(props.row)"
							>
							</v-switch>
						</v-btn>
						<span>Cambiar Estado</span>
					</v-tooltip>
					<app-tooltip-button
						color="red"
						icon="devices"
						text="Dispositivos"
					/>
					<app-tooltip-button
						color="blue"
						icon="description"
						text="Asignar Aplicaciones"
						@click-icon="openApps(props.row)"
					/>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar"
						@click-icon="openEdit(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="vpn_key"
						text="Editar contraseña"
						@click-icon="change(props.row)"
					/>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function change({ codeUser }) {
	const codeProject = this.codeProject;
	this.goTo('page-users-change-password', { params: { id: codeUser, codeProject } });
}

function changePage(page) {
	this.$emit('change-page', page);
}

function changeState(user) {
	const model = { user, codeProject: this.codeProject, codeCompany: this.companyCode };
	this.$emit('change-state', model);
}

function openApps({ codeUser }) {
	const codeProject = this.codeProject;
	const idCompany = this.companyCode;
	this.goTo('page-app-user', { params: { codeProject, idCompany, codeUser } });
}

function openEdit({ id }) {
	const codeProject = this.codeProject;
	const companyCode = this.companyCode;
	this.goTo('page-user-edit', { params: { codeProject, companyCode, id } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}

export default {
	name: 'users-list',
	components: {
		appTooltipButton,
	},
	methods: {
		changePage,
		changeState,
		openApps,
		openEdit,
		onSearch,
		change,
	},
	props: {
		codeProject: {
			type: String,
		},
		columns: {
			type: Array,
			required: true,
		},
		companyCode: {
			type: String,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/users/users-list.vue